import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../utils/axiosInstance';

const useDataSelect = (apiEndpoint) => {
  const [dataset, setDataset] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(apiEndpoint);
      setDataset(response.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'データの取得に失敗しました');
      setDataset([]);
      if (process.env.NODE_ENV === 'development') {
        console.error(err);
      }
    } finally {
      setLoading(false);
    }
  }, [apiEndpoint]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { dataset, setDataset, loading, error, refetch: fetchData };
};

export default useDataSelect;
